export const setLocations = (locations) => {
    return {
        type: 'SET_LOCATIONS',
        locations
    };
};

export const setTaskItem = (taskItem) => {
    return {
        type: 'SET_TASK',
        taskItem
    };
};

export const resetLocations = () => {
    return {
        type: 'RESET_LOCATIONS'
    };
};

export const setTwoSteps = (twoSteps) => {
    return {
        type: 'SET_TWO_STEPS',
        twoSteps
    };
};